// extracted by mini-css-extract-plugin
export default {"cls1":"kiDQAJ6G_EyVHBX5JDdA","cls2":"sbILH__0bp4WtJ_60HwS kiDQAJ6G_EyVHBX5JDdA","roll":"GLXOGWGNkId3BDPe9l0Q","visible":"YMIX8PBubdo7LegsPtUL"};